<template>
    <div>
        <!-- FILTERS -->
        <!-- TABLE -->
        <el-table
            class="br br-top-0 report-activity-list"
            border
            cell-class-name="py-3"
            :default-expand-all="isStaffReport"
            row-key="id"
            :row-class-name="isGroupRow"
            :data="rows"
        >
            <el-table-column
                v-if="isStaffReport"
                prop="name"
                :label="$t.__('activities.reports.ActivitesReportListing.group')"
            >
            </el-table-column>
            <el-table-column
                v-if="isStaffReport"
                prop="staff"
                :label="$t.__('common.labels.staff')"
            >
                <span slot-scope="{ row }" class="flex-level">
                    <span v-if="row.children">{{ $l10n.__('Totaux groupe:') }}</span>
                    <span v-else>
                        <avatar-inline :data="row"></avatar-inline>
                    </span>
                </span>
            </el-table-column>
            <el-table-column
                v-else
                prop="period"
                :label="$t.__('activities.reports.ActivitesReportListing.period')"
            >
                <template slot-scope="scope">
                    {{ scope.row.period }}
                </template>
            </el-table-column>
            <el-table-column
                prop="tasks"
                :label="$t.__('activities.reports.ActivitesReportListing.task_completed')"
            >
            </el-table-column>
            <el-table-column
                prop="calls"
                :label="$t.__('activities.reports.ActivitesReportListing.call_placed')"
            >
            </el-table-column>
            <el-table-column
                prop="emails"
                :label="$t.__('activities.reports.ActivitesReportListing.email_sent')"
            >
            </el-table-column>
            <el-table-column
                prop="events"
                :label="$t.__('activities.reports.ActivitesReportListing.past_event')"
            >
            </el-table-column>
            <el-table-column
                prop="total"
                :label="$t.__('activities.reports.ActivitesReportListing.total')"
            >
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AvatarInline from 'vcomponents/utilities/AvatarInline.vue';
import Avatar from 'vcomponents/utilities/Avatar.vue';

const report = createNamespacedHelpers('report');
export default {
    computed: {
        ...report.mapGetters(['rows', 'type']),
        isStaffReport() {
            return this.type === 'staff';
        },
    },
    methods: {
        isGroupRow({ row }) {
            return !!row.children ? 'lightgrey-bkg' : '';
        },
    },
    components: {
        AvatarInline,
        Avatar,
    },
};
</script>

<style lang="scss">
.report-activity-list .el-table__expand-icon.el-table__expand-icon--expanded {
    display: none !important;
}
</style>
